// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAgreement_wrapper__PeG4C","content":"UserAgreement_content__8BHhv","agreements":"UserAgreement_agreements__OkHt4"};